import ManifestScreen from "./index";

const routes = [
  {
    path: "/manifest/:id",
    component: ManifestScreen,
  },
];

export default routes;
